import * as Yup from "yup";
import { socialCodes } from "../../../../utils/dataAndFormulas/socialForms";

export function initialValues(site, period, year, unitsRecorded) {
 // console.log('🔍 SocialForm initialValues - unitsRecorded recibido:', unitsRecorded);
  return {
    date: site?.date || "",
    creator_user: site?.creator_user || "",
    state: site?.state || "",
    period: site?.period || period,
    year: site?.year || year,
    days_worked: site?.days_worked || {
      code: socialCodes["days_worked"],
      value: 0,
      unit: unitsRecorded?.["days_worked"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    normal_hours_worked: site?.normal_hours_worked || {
      code: socialCodes["normal_hours_worked"],
      value: 0,
      unit: unitsRecorded?.["normal_hours_worked"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    fifty_percent_overtime: site?.fifty_percent_overtime || {
      code: socialCodes["fifty_percent_overtime"],
      value: 0,
      unit: unitsRecorded?.["fifty_percent_overtime"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    one_hundred_percent_overtime: site?.one_hundred_percent_overtime || {
      code: socialCodes["one_hundred_percent_overtime"],
      value: 0,
      unit: unitsRecorded?.["one_hundred_percent_overtime"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    female_production_workers: site?.female_production_workers || {
      code: socialCodes["female_production_workers"],
      value: 0,
      unit: unitsRecorded?.["female_production_workers"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    male_production_workers: site?.male_production_workers || {
      code: socialCodes["male_production_workers"],
      value: 0,
      unit: unitsRecorded?.["male_production_workers"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    other_gender_production_workers: site?.other_gender_production_workers || {
      code: socialCodes["other_gender_production_workers"],
      value: 0,
      unit: unitsRecorded?.["other_gender_production_workers"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    female_administrative_workers: site?.female_administrative_workers || {
      code: socialCodes["female_administrative_workers"],
      value: 0,
      unit: unitsRecorded?.["female_administrative_workers"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    male_administrative_workers: site?.male_administrative_workers || {
      code: socialCodes["male_administrative_workers"],
      value: 0,
      unit: unitsRecorded?.["male_administrative_workers"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    administrative_workers_other_genders:
      site?.administrative_workers_other_genders || {
        code: socialCodes["administrative_workers_other_genders"],
        value: 0,
        unit: unitsRecorded?.["administrative_workers_other_genders"] || "",
        reviews: [],
        files: [],
        approvalStatus: "pending",
      },
    female_temporary_workers: site?.female_temporary_workers || {
      code: socialCodes["female_temporary_workers"],
      value: 0,
      unit: unitsRecorded?.["female_temporary_workers"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    male_temporary_workers: site?.male_temporary_workers || {
      code: socialCodes["male_temporary_workers"],
      value: 0,
      unit: unitsRecorded?.["male_temporary_workers"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    temporary_workers_other_genders: site?.temporary_workers_other_genders || {
      code: socialCodes["temporary_workers_other_genders"],
      value: 0,
      unit: unitsRecorded?.["temporary_workers_other_genders"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    female_workers_leadership_positions:
      site?.female_workers_leadership_positions || {
        code: socialCodes["female_workers_leadership_positions"],
        value: 0,
        unit: unitsRecorded?.["female_workers_leadership_positions"] || "",
        reviews: [],
        files: [],
        approvalStatus: "pending",
      },
    male_workers_leadership_positions:
      site?.male_workers_leadership_positions || {
        code: socialCodes["male_workers_leadership_positions"],
        value: 0,
        unit: unitsRecorded?.["male_workers_leadership_positions"] || "",
        reviews: [],
        files: [],
        approvalStatus: "pending",
      },
    workers_under_cct: site?.workers_under_cct || {
      code: socialCodes["workers_under_cct"],
      value: 0,
      unit: unitsRecorded?.["workers_under_cct"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    work_accidents_with_sick_days: site?.work_accidents_with_sick_days || {
      code: socialCodes["work_accidents_with_sick_days"],
      value: 0,
      unit: unitsRecorded?.["work_accidents_with_sick_days"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    in_itine_accidents: site?.in_itine_accidents || {
      code: socialCodes["in_itine_accidents"],
      value: 0,
      unit: unitsRecorded?.["in_itine_accidents"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    first_aid_without_sick_days: site?.first_aid_without_sick_days || {
      code: socialCodes["first_aid_without_sick_days"],
      value: 0,
      unit: unitsRecorded?.["first_aid_without_sick_days"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },

    hours_training_social_issues: site?.hours_training_social_issues || {
      code: socialCodes["hours_training_social_issues"],
      value: 0,
      unit: unitsRecorded?.["hours_training_social_issues"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    hours_training_hys: site?.hours_training_hys || {
      code: socialCodes["hours_training_hys"],
      value: 0,
      unit: unitsRecorded?.["hours_training_hys"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    hours_environmental_awareness_training:
      site?.hours_environmental_awareness_training || {
        code: socialCodes["hours_environmental_awareness_training"],
        value: 0,
        unit: unitsRecorded?.["hours_environmental_awareness_training"] || "",
        reviews: [],
        files: [],
        approvalStatus: "pending",
      },
    volunteer_hours: site?.volunteer_hours || {
      code: socialCodes["volunteer_hours"],
      value: 0,
      unit: unitsRecorded?.["volunteer_hours"] || "",
      reviews: [],
      files: [],
      approvalStatus: "pending",
    },
    complaints_or_suggestions_received:
      site?.complaints_or_suggestions_received || {
        code: socialCodes["complaints_or_suggestions_received"],
        value: 0,
        unit: unitsRecorded?.["complaints_or_suggestions_received"] || "",
        reviews: [],
        files: [],
        approvalStatus: "pending",
      },
  };
}

export function validationSchema() {
  // Función helper para los campos tipo { value, unit }
  const numberWithUnit = () =>
    Yup.object({
      value: Yup.number()
        .nullable()
        .transform((val, originalVal) => (originalVal === "" ? null : val))
        .min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val != null && val !== 0,
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    });

  return Yup.object({
    period: Yup.string().required("El campo periodo es obligatorio"),

    days_worked: numberWithUnit(),
    normal_hours_worked: numberWithUnit(),
    steam_condensed_water: numberWithUnit(),
    fifty_percent_overtime: numberWithUnit(),
    one_hundred_percent_overtime: numberWithUnit(),

    female_production_workers: numberWithUnit(),
    male_production_workers: numberWithUnit(),
    other_gender_production_workers: numberWithUnit(),

    female_administrative_workers: numberWithUnit(),
    male_administrative_workers: numberWithUnit(),
    administrative_workers_other_genders: numberWithUnit(),

    female_temporary_workers: numberWithUnit(),
    male_temporary_workers: numberWithUnit(),
    temporary_workers_other_genders: numberWithUnit(),

    male_workers_leadership_positions: numberWithUnit(),
    workers_under_cct: numberWithUnit(),

    work_accidents_with_sick_days: numberWithUnit(),
    in_itine_accidents: numberWithUnit(),
    first_aid_without_sick_days: numberWithUnit(),

    hours_training_social_issues: numberWithUnit(),
    hours_training_hys: numberWithUnit(),
    hours_environmental_awareness_training: numberWithUnit(),

    volunteer_hours: numberWithUnit(),
    complaints_or_suggestions_received: numberWithUnit(),
  });
}
